// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw Online Ultiem',
  freeTimesLimitTitle: 'De gratis proefversie is vandaag op.',
  fileSizeLimitTitle:
    'De bestandsgrootte mag niet groter zijn dan 20 MB in gratis versie.',
  freeImgCutoutTimesLimitTitle:
    'De testmogelijkheid van vandaag voor achtergrondverwijdering is verlopen, upgrade alstublieft naar Pro om toegang te krijgen tot alle premium functies',
  total: 'Totaal',
  enterCode: 'Voer code in',
  signUpToPurchaseBtn: 'Meld u aan om te kopen',
  goPurchseBtn: 'Ga naar Kopen',
  saveTips: 'Bespaar tot {{num}}%',
  discount: 'Korting',
  priceWeek: '$ 9,99',
  priceMonth: '$ 7,49',
  priceYear: '$ 3,75',
  billedMonth: '$29,99 Maandelijks gefactureerd',
  billedYear: '$179,99 Jaarlijks gefactureerd',
  monthly: 'Maandelijks',
  yearly: 'Jaarlijks',
  weekly: 'Wekelijks',
  week: 'Week',
  AlreadySubscribe: 'Al geabonneerd?',
  vipTips1: 'Geen bestandsgrootte limieten',
  vipTips2: 'Geen limiet aan het aantal verwerkte bestanden',
  vipTips3: 'Wijzig beeldachtergronden zonder limieten',
  vipTips4: 'Toegang tot alle gratis tools en premium -functies',
  purchaseTips: 'Automatisch verlengen en op elk moment opzeggen.',
  tips: 'Tips:',
  promoCodeInvalidTips: 'Uw promotiecode is ongeldig',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
